const ShortLoading = () => {
  return (
    <div className="flex justify-center items-center min-h-96 text-primary">
      <span className="loading loading-infinity w-24 h-24" />
    </div>
  );
};

export default ShortLoading;
